import * as React from 'react';
import { useTheme } from '@mui/material';

import { EOnboardingStep } from 'enums';
import { StatusDots } from './status-dots';

interface OnboardingStatusDotsProps {
  status?: EOnboardingStep;
}

export const OnboardingStatusDots = ({ status = EOnboardingStep.SETUP_BUILDING }: OnboardingStatusDotsProps) => {
  const theme = useTheme();

  const dots = [1, 2, 3, 4, 5, 6];

  const getBgColor = (dotIndex: number) => {
    if (dotIndex === dots[0] && status === EOnboardingStep.SETUP_BUILDING) {
      return theme.palette.primary.main;
    }

    if (dotIndex === dots[1] && status === EOnboardingStep.SETUP_ZONE) {
      return theme.palette.primary.main;
    }

    if (dotIndex === dots[2] && status === EOnboardingStep.COMPANY_BRAND_SETTING) {
      return theme.palette.primary.main;
    }

    if (dotIndex === dots[3] && status === EOnboardingStep.APPROVE_DECAL) {
      return theme.palette.primary.main;
    }

    if (dotIndex === dots[4] && status === EOnboardingStep.ASSIGN_EMPLOYEE) {
      return theme.palette.primary.main;
    }

    if (dotIndex === dots[5] && status === EOnboardingStep.ONBOARDING_REVIEW) {
      return theme.palette.primary.main;
    }

    return '#C4C4C4';
  };

  return <StatusDots dots={dots} getBgColor={getBgColor} />;
};
